module.exports = __webpack_public_path__ + "img/Auditing-and-accountability-2.1786a179.png";